import * as types from './actionTypes';

export function setResourcesDisplay(displayResources){
    return { type: types.SET_RESOURCES_DISPLAY, displayResources };
}

export function setResourcesProps(resourceProps){
    return { type: types.SET_RESOURCES_PROPS, resourceProps };
}


/** WEBPACK FOOTER **
 ** ./src/actions/resourcesActions.js
 **/